import React, { Component } from 'react';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles, createStyles } from '@material-ui/core/styles';

import HeroVideo from '../Hero/HeroVideo';

import NewsFeed from '../NewsFeed';
import Video from '../Video';
import Events from '../Calendar/Event';
import Map from '../Map';
import SponsorStream from '../SponsorStream';
import InstaCarousel from '../SocialStream/Carousel';
import SportsCards from '../Card/IconCard/SportsCards';
import ShortcutList from '../Navigation/ShortcutList';
import Section, { Heading, Subtitle } from '../Section';
import Carousel from '../Carousel';


const styles = ({ palette }: Theme) => createStyles({
  root: {

  },
  CalendarSection: {
    backgroundImage: "url('/includes/images/bkgd/baseball_field.jpg')",
    backgroundPosition: "center",
    backgroundSize: "cover",
    opacity: "0.3",
  },
  ArticleSection: {
    //backgroundImage: "url('/includes/images/basketball.jpg')" ,
    backgroundColor: "gray",
    backgroundPosition: "center",
    backgroundSize: "cover",
    opacity: "0.5",
  },
  TestimonialSection: {
    backgroundImage: "url('/includes/images/bkgd/football_grass.jpg')",
    backgroundPosition: "center",
    backgroundSize: "cover",
    opacity: "1",
  },
  SportsCardSection: {
    backgroundImage: "url('/includes/images/baseball2.jpg')" ,
    backgroundPosition: "center",
    backgroundSize: "cover",
    opacity: "0.25",
  },
  SportsmanshipSection: {
    backgroundColor: "rgba(2,173,231,0.8)",
    backgroundImage: "url('/includes/images/refSoccer.jpg')",
    //background: "rgba(2,173,231,0.5), url('/includes/images/refSoccer.jpg')",
    backgroundPosition: "center",
    backgroundSize: "cover",
    opacity: ".3",
  },
  MapSection: {
    backgroundImage: "url('/includes/images/bkgd/campus_sky.jpg')",
    //backgroundColor: "gray",
    backgroundPosition: "bottom",
    backgroundSize: "cover",
    opacity: ".2",
  },
  SponsorSection: {
    backgroundImage: "url('/includes/images/bkgd/baseball_field.jpg')",
    backgroundPosition: "bottom",
    backgroundSize: "cover",
    opacity: "1",
  },
  contrastText: {
    color: palette.primary.contrastText,
  },
  shadowText: {
    //color: palette.primary.contrastText,
    textShadow: "0px 0px 2px white",
  },
  SocialSection: {
    //backgroundImage: "url('/includes/images/field.jpg')" ,
    //backgroundColor: palette.secondary.main,
    backgroundPosition: "center",
    backgroundSize: "cover",
    opacity: "0.25",
  },
  overlayLight: {
    backgroundColor: "rgba(256,256,256,.7)",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  blue: {
    backgroundColor: "rgba(0,100,200,.2)",
  },
  sportmanshipCard: {
    height: "200px",
  }


});

const news = [
  {
    image: "/includes/images/refSoccer2.jpg",
    title: "Become A Referee",
    subtitle1: "T&C Soccer",
    subtitle2: "Apply Today!",
    button: "Learn More",
  },
  {
    image: "/includes/images/golfFlyer.png",
    title: "Golfers Needed",
    subtitle1: "",
    subtitle2: "",
    button: "Sign Up",
  },
  {
    image: "/includes/images/baseball2.jpg",
    title: "Open Registration",
    subtitle1: "T&C Baseball",
    subtitle2: "Apply Today!",
    button: "Register Now!",
  },
];

const sponsors = [
  {
    name: "ABC Home & Commercial Services",
    img: "data:image/png;base64,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",
    website:"https://www.abchomeandcommercial.com",
  },
  {
    name: "Academy",
    img: "https://photos.prnewswire.com/prnfull/20091125/DA17612LOGO",
    website: "https://www.academy.com",
  },
  {
    name: "Kona Ice",
    img: "https://www.kona-ice.com/images/logo.png",
    website: "https://www.kona-ice.com/",
  },
  {
    name: "Sport Court",
    img: "https://cdn.sqhk.co/2020newsportcourt/2020/4/dgdN5sL/SportCourtlogo_Horizonal_White2copy.png",
    website: "https://www.sportcourt.com/"
  },
  {
    name: "Viatran",
    img: "https://viatraninc.com/wp-content/uploads/Logos_and_Artwork/Viatran/viatran-1-e1500047070333.png",
    website: "https://viatraninc.com",
  },
  {
    name: "Play It Again Sports",
    img: "https://playitagainsports.imgix.net/buyerweb/assets/_pias/_svg/pias__logo.svg",
    website: "https://playitagainsports.com",
  },
  {
    name: "Mighty Fine",
    img: "https://mightyfineburgers.com/wp-content/uploads/2013/02/mighty_fine_logo.png",
    website: "https://mightyfineburgers.com",
  },
  {
    name: "Crown Trophy",
    img: "https://www.crowntrophy.com/pub/static/version1587591032/frontend/crown-trophy/theme-frontend/en_US/images/logo.jpg",
    website: "https://www.crowntrophy.com",
  },
  {
    name: "ABC Copy Co",
    img: "https://www.abchomeandcommercial.com/theme/ABC/images/abc-logo-white.svg",
    website: "https://www.abccopyco.com"
  },
  {
    name: "Lonestare Technology Services",
    img: "https://files.constantcontact.com/c35a3a2a701/cacdc23d-684b-4d22-8ddd-2dc570944666.jpg",
    website: "",
  },
]

const shortcuts=[
  {
    heading: "PLAY",
    links: [
      {
        label: "Register",
        to: "",
      },
      {
        label: "Program Info",
        to: "",
      },
      {
        label: "Team Schedules",
        to: "",
      },
    ]
  },
  {
    heading: "VISIT",
    links: [
      {
        label: "Field Status",
        to: "",
      },
      {
        label: "Field Maps",
        to: "",
      },
      {
        label: "Direction",
        to: "",
      },
    ]
  },
  {
    heading: "HELP",
    links: [
      {
        label: "Coach",
        to: "",
      },
      {
        label: "Volunteer",
        to: "",
      },
      {
        label: "Donate",
        to: "",
      },
    ]
  }
]



class App extends Component{

  render() {
    const { classes } = this.props;

    return (
      <Box align="center">
        <HeroVideo
          source= "/includes/images/VID_20191104_185523.mp4"
          title="T&C Sports"
          tagline="Your Home For Youth Sports"
          menu={ true }
        />

        <Grid container justify="center">
            <ShortcutList linkGroups={ shortcuts } elevation={10} mb={4} mt={-12} xs={11} md={7} align="center" classes={{ root: classes.shortcutList }}/>
        </Grid>

        <Section classes={{ background: classes.CalendarSection }}>
          <Heading>
            Events
          </Heading>
          <Events />
        </Section>

        <Section classes={{ background: classes.ArticleSection }}>
          <NewsFeed xs={10} mb={8} mt={4} backgroundColor="DarkGray" articles={ news }/>
        </Section>

        <Section classes={{ background: classes.TestimonialSection }}>
          <Heading classes={{ text: classes.shadowText }}>
            Play at T&C Sports
          </Heading>
          <Grid container justify="center" spacing={2}>
            <Grid item xs={12} md={5}>
              <Paper>
                <Box p={2} height="100%">
                  <Typography
                    variant="body1"
                    component="p"
                    align="justify"
                  >
                    T&C Sports offers 7 team sports for kids from pre-k through high school on our 95 acre campus in northwest Austin. <br/><br/>
                    All of our sports have affordable recreational leagues with an emphasis on having fun in a family atmosphere.<br/><br/>
                    They are coached primarily by certified and background-checked volunteers.<br/><br/>
                    Several T&C sports also offer a select level of play in competitive leagues, with more advanced training.<br/><br/>
                    T&C Sports is sponsored by Town & Country Optimist Club and we teach the Optimist values of respect, teamwork, and fair play.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={10} md={5}>
              <Paper>
                <Box p={1}>
                  <Video
                    source="/includes/images/flyover.mp4"
                    elevation={2}
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Section>

        <Section classes={{ background: classes.SportsCardSection }}>
          <Heading>
            Join Our Youth Sports
          </Heading>
          <Box>
            <SportsCards />
          </Box>
        </Section>

        <Section classes={{ background: classes.SportsmanshipSection }}>
          <Heading>
            Sportsmanship
          </Heading>
          <Grid container spacing={8} justify="center">
            <Grid item xs={12} md={5}>
              <Typography
                variant="body1"
                component="p"
                align="justify"
                paragraph={true}
              >
                Developing good character in our players is a core element of T&C’s mission.  Coaches teach not only skills, but the values of sportsmanship.  We think all adults are role models at T&C, whether they are coaches or parents watching a game.  Everyone is expected to demonstrate respect and positive behavior on the field, in the stands, and even in our parking lots.  We have zero tolerance for abuse of any kind.
              </Typography>
            </Grid>
            <Grid item xs={11} md={4} >
              <Carousel classes={{ card: classes.sportmanshipCard }} fade="true">
                <img src="https://cdn2.sportngin.com/attachments/photo/825f-141969332/if-i-were-a-parent-sportsmanship_large.jpg"
                  alt=""
                  height="100%"/>
                <img src="https://res.cloudinary.com/little-league/image/upload/c_limit,dpr_auto,w_1536,q_auto,c_fill,g_face/v1520559630/Sportsmanship.jpg"
                  alt=""
                  height="100%"/>
                <img src="https://activeforlife.com/content/uploads/2014/10/girls-soccer-sportsmanship.jpg"
                  alt=""
                  height="100%"/>
                <img src="https://www.robertglazer.com/wp-content/uploads/2018/06/FF_130_GettyImages-471019485.jpg"
                  alt=""
                  height="100%"/>
              </Carousel>
            </Grid>
          </Grid>
        </Section>

        <Section classes={{ background: classes.MapSection, overlay: classes.blue }} xs={12} md={11}>
          <Heading>
            How To Find T&C
          </Heading>
          <Map />
        </Section>

        <Section classes={{ background: classes.SponsorSection }} xs={12} md={11}>
          <Heading classes={{ text: classes.contrastText }}>
            Our Sponsors
          </Heading>
          <Subtitle classes={{ text: classes.contrastText }}>
            WE COULDN"T DO WHAT WE DO WITHOUT THEM
          </Subtitle>
          <SponsorStream sponsors={ sponsors }/>
        </Section>

        <Section classes={{ background: classes.SocialSection }} xs={12} md={11}>
          <Heading>
            #TandCSports
          </Heading>
          <Subtitle>
            THE BIG PICTURE IN SMALL PHOTOS - SHARE YOUR FAVORITE MOMENTS WITH US!
          </Subtitle>
          <InstaCarousel account="tandcsports" numberOfMediaElements={6} />
        </Section>

      </Box>
    );
  }
}


export default withStyles(styles)(App);
